import { DocumentType } from "../generated/api-client";

export const documentTypeValues: DocumentType[] = [
    "Dni",
    "Passport",
    "Other",
];

export const documentTypeLabels: Record<DocumentType, string> = {
    Dni: "Documento",
    Passport: "Pasaporte",
    Other: "Otro",
};

export const documentTypeOptions = documentTypeValues.map(value => ({
    value,
    label: documentTypeLabels[value],
}));
